module.exports = __webpack_public_path__ + "static/media/dummy_sound.23a8d392.m4a";